import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import {
  FieldArray,
} from 'formik';

import { SortableList } from '../sortable-component';
import PreviewStudyButton from '../../../core/components/preview-study-button';

import {
  Dropdown,
  DropdownMenu,
  ContainerAddQuestion,
  TextAddQuestion,
  CircleItem,
  Icon,
  ContainerDropdown,
} from './styles';
import {
  ACTIVITIES, QUESTION_TYPE_ENUM, TEST_TYPE_ENUM, TREE_TEST_QUESTION_TYPES, SURVEY_QUESTION_TYPES, ASSETS, UNMOD_QUESTION_TYPES,
} from './constants';
import { QuestionsColumn } from './dropdown-columns/questions-column';
import QuestionSegment from './question-segment';

// todo: move to functional component
class QuestionsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isUploadDone: true,
    };
  }

  handleQuestions = (setIsUploadDone) => (
    this.props.values.tasks.map((task, index) => (
      <QuestionSegment
        key={task.id}
        index={index}
        task={task}
        setIsUploadDone={setIsUploadDone}
        errors={this.props.errors}
        handleRemoveQuestion={this.props.handleRemoveQuestion}
        touched={this.props.touched}
        isEdit={this.props.isEdit}
        hideTrashCan={this.props.hideTrashCan}
        setFieldValue={this.props.setFieldValue}
        onClickDuplicate={this.props.onClickDuplicate}
        onChangeUrl={this.props.onChangeUrl}
        taskIndex={this.props.taskIndex}
        testType={this.props.testType}
      />
    ))
  );

  render() {
    const {
      handleNewQuestion,
      handleSortOnEnd,
      isEdit,
      values,
      handlePreviewStudy,
      previewButtonClicked,
      addQuestionOnRight,
      textAddQuestion,
      small,
      testType,
    } = this.props;

    const setIsUploadDone = (isUploadDone) => {
      this.setState({ isUploadDone });
    };

    const isSurvey = testType === TEST_TYPE_ENUM.survey;
    const isTreeTest = testType === TEST_TYPE_ENUM.tree_test;
    const isUnmoderated = testType === TEST_TYPE_ENUM.unmoderated;
    const unmoderatedQuestions = UNMOD_QUESTION_TYPES;

    const renderDropdownExtraContent = () => {
      let questionsObject = {};
      let headerText = '';
      switch (testType) {
        case TEST_TYPE_ENUM.survey:
          questionsObject = ACTIVITIES;
          headerText = 'Activities';
          break;
        case TEST_TYPE_ENUM.unmoderated:
          questionsObject = ASSETS;
          headerText = 'Assets';
          break;
        default:
          break;
      }
      return (
        <QuestionsColumn
          questions={questionsObject}
          headerText={headerText}
          onNewQuestion={handleNewQuestion}
        />
      );
    };

    const handleQuestionTypes = () => {
      switch (true) {
        case isTreeTest:
          return TREE_TEST_QUESTION_TYPES;
        case isSurvey:
          QUESTION_TYPE_ENUM[0].label = 'Instructions';
          return SURVEY_QUESTION_TYPES;
        case isUnmoderated:
          return unmoderatedQuestions;
        default:
          return QUESTION_TYPE_ENUM;
      }
    };

    return (
      <FieldArray
        name="tasks"
        render={() => (
          <div>
            {!isEdit && values.tasks && (
              <SortableList
                items={this.handleQuestions(setIsUploadDone)}
                onSortEnd={handleSortOnEnd}
                spaceRight="2%"
                marginTop="21px"
                disabled={!this.state.isUploadDone}
              />
            )}

            {isEdit && values.tasks && values.tasks.map((task, index) => (
              <QuestionSegment
                key={task.id}
                index={index}
                task={task}
                errors={this.props.errors}
                handleRemoveQuestion={this.props.handleRemoveQuestion}
                touched={this.props.touched}
                isEdit={this.props.isEdit}
                hideTrashCan={this.props.hideTrashCan}
                setFieldValue={this.props.setFieldValue}
                onClickDuplicate={this.props.onClickDuplicate}
                onChangeUrl={this.props.onChangeUrl}
                taskIndex={this.props.taskIndex}
                testType={this.props.testType}
              />
            ))}

            {!isEdit && (
              <ContainerDropdown right={addQuestionOnRight}>
                <Dropdown
                  item
                  trigger={(
                    <ContainerAddQuestion>
                      <CircleItem small={small}>
                        <Icon name="plus" small={small} />
                      </CircleItem>
                      <TextAddQuestion small={small}>{textAddQuestion}</TextAddQuestion>
                    </ContainerAddQuestion>
                  )}
                >
                  <DropdownMenu direction="bottom">
                    <div>
                      <QuestionsColumn
                        questions={handleQuestionTypes()}
                        headerText="Questions"
                        onNewQuestion={handleNewQuestion}
                      />

                      {isSurvey || isUnmoderated ? renderDropdownExtraContent() : null}

                    </div>
                  </DropdownMenu>
                </Dropdown>

                {handlePreviewStudy && (
                  <PreviewStudyButton
                    onPreviewStudy={handlePreviewStudy}
                    loading={previewButtonClicked}
                    disabled={values.tasks && values.tasks?.length === 0}
                  />
                )}
              </ContainerDropdown>
            )}
          </div>
        )}
      />
    );
  }
}

QuestionsForm.propTypes = {
  addQuestionOnRight: PropTypes.bool,
  isEdit: PropTypes.bool,
  values: PropTypes.shape().isRequired,
  errors: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  touched: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  handleSortOnEnd: PropTypes.func,
  handleRemoveQuestion: PropTypes.func.isRequired,
  handleNewQuestion: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  hideTrashCan: PropTypes.bool,
  onClickDuplicate: PropTypes.func,
  handlePreviewStudy: PropTypes.func,
  previewButtonClicked: PropTypes.bool,
  onChangeUrl: PropTypes.func,
  taskIndex: PropTypes.number,
  textAddQuestion: PropTypes.string,
  small: PropTypes.bool,
  testType: PropTypes.string.isRequired,
};

QuestionsForm.defaultProps = {
  addQuestionOnRight: false,
  isEdit: false,
  hideTrashCan: false,
  onClickDuplicate: () => { },
  handlePreviewStudy: null,
  previewButtonClicked: false,
  onChangeUrl: null,
  taskIndex: null,
  textAddQuestion: 'Add new question',
  small: false,
  handleSortOnEnd: null,
};

export default QuestionsForm;
